module.exports = __webpack_public_path__ + "static/img/ui_frame_pc_l.01cb53ac.png";